import React from 'react';
import { Link } from 'react-router-dom';
import AppVersion from '../common/AppVersion';

export default function FOOTER() {
	return (
		<footer className="fixed bottom-0 w-[1224px] flex flex-row justify-around items-center h-[30px] bg-[#424274] text-white">
			<AppVersion />
      <div>&#169; 2025 by PerCentage Corporation</div>
			<Link
					to='#'
					onClick={(e) => {
							window.location.href = "mailto:mismo@percentage.net";
							e.preventDefault();
					}}
			>
				Contact EMail
			</Link>			
		</footer>
	)
}
